import { Navigate, useRouter } from '@tanstack/react-router';

import { useGoBack } from '@libs/hooks/useGoBack';

import { useAuth } from '@features/auth/hooks/useAuth';
import { useClubCardQuery } from '@features/club/api/hooks';
import { SomePlayerProfilePage } from '@features/user/pages/SomePlayerProfilePage/SomePlayerProfilePage';
import { PlayerShieldAvatarWidget } from '@features/user/ui/PlayerShieldAvatar';
import { SomePlayerStatsWidget } from '@features/user/ui/SomePlayerStats/SomePlayerStatsWidget';
import { UserAuthMenuWidget } from '@features/user/ui/UserAuthMenu/UserAuthMenuWidget';
import { UserSettingsMenuWidget } from '@features/user/ui/UserSettingsMenu/UserSettingsMenuWidget';

type Props = {
  userId: string;
};
export function SomePlayerProfilePageWidget({ userId }: Props) {
  const router = useRouter();
  const { isAuthenticated, user } = useAuth();
  const firstClubId = user?.clubs && Object.keys(user.clubs)[0];
  const { data: club } = useClubCardQuery(firstClubId, { staleTime: Infinity });
  const themeColor = club?.themeColor;

  const onBack = useGoBack();

  // TODO убрать это, когда ручки будут доступны для анонимов
  if (!isAuthenticated) {
    return <Navigate to="/auth/required" search={{ back: router.latestLocation.href }} />;
  }

  return (
    <SomePlayerProfilePage
      shieldAvatar={<PlayerShieldAvatarWidget userId={userId} />}
      stats={<SomePlayerStatsWidget userId={userId} />}
      actions={
        <>
          <UserSettingsMenuWidget />
          <UserAuthMenuWidget />
        </>
      }
      themeColor={themeColor}
      onBack={onBack}
    />
  );
}
